import { locationIdFormat } from "@redotech/redo-ids/ids";
import { RedoFulfillmentToteSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote";
import { RedoFulfillmentToteGroupSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote-group";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const duplicateToteGroup = {
  name: "duplicateToteGroup" as const,
  input: z.object({
    toteGroupId: zExt.objectId(),
    newGroupName: z.string(),
    toteNames: z.array(z.string()),
    locationId: locationIdFormat.schema,
  }),
  output: z.object({
    toteGroup: RedoFulfillmentToteGroupSchema,
    totes: z.array(RedoFulfillmentToteSchema),
  }),
};
